import { fetchEndpoint } from '../server/network';

// 我的余额
export const balanceTotal =
() =>
fetchEndpoint(
  '/v2/ecapi.balance.get',
  'POST',
  {
  }
)


// 充值接口
export const recharge = (cash,code,openid,referer) =>
    fetchEndpoint(
      '/v2/ecapi.account.deposit',
      'POST',
      { 
        cash,    //	金额
        code,    // 支付方式 alipay.app,wxpay.app,wxpay.web,teegon.wap,alipay.wap,wxpay.wxa,wxpay.h5
        openid,  //openid 如果是公众号支付，必填
        referer, //openid 如果是h5支付，必填
      }
    )

// 我的余额列表
export const balanceList =
(status, page, per_page) =>
fetchEndpoint(
  '/v2/ecapi.balance.list',
  'POST',
  {
    "status": status,  // 状态   全部  收入  支出
    "page": page,  // 当前第几页
    "per_page": per_page,  // 每页多少
  }
)




// WEBPACK FOOTER //
// ./src/api/balance.js